import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const companyService = {
  getAllCompanies,
};

const MODULE = {
  COMPANY: 'public-companies',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v2'


export function getAllCompanies(filter) {
  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
      group_id: filter.groupID, 
      company: filter.companyID, 
      is_locked: filter.isLocked,
      is_active: filter.isActive,
    }
  }
  
  let array = filter.searchArray
  array.forEach((word, index) => {
    if (word != null || word != '') {
      var searchParam = `search_words[${index}]`
      requestOptions.params[searchParam] = word
    }
  })

  return apiHelper(API_URL).get(`/${MODULE.COMPANY}`, requestOptions)
}